import {AssetSolarWithdrawalVerboseDomain} from "../../domain/asset/AssetSolarWithdrawalVerboseDomain"
import {AssetSolarUsageId} from "../../id/asset/AssetSolarUsageId"
import {AssetSolarWithdrawalId} from "../../id/asset/AssetSolarWithdrawalId"
import {EnvBankId} from "../../id/env/EnvBankId"
import {EnvBankValueObject} from "../env/EnvBankValueObject"
import {AssetSolarUsageValueObject} from "./AssetSolarUsageValueObject"
import {VerboseValueObject} from "ts-protocol-extension"

/**
 * 솔라 인출 상세
 */
export class AssetSolarWithdrawalVerboseValueObject implements VerboseValueObject, AssetSolarWithdrawalVerboseDomain {
    /**
     * 기본키
     */
    id: AssetSolarWithdrawalId
    /**
     * 솔라 사용 ID
     */
    assetSolarUsageId: AssetSolarUsageId
    /**
     * 은행 ID
     */
    envBankId: EnvBankId
    /**
     * 계좌번호
     */
    account: string
    /**
     * 요청 금액(원)
     */
    cashAmount: number
    /**
     * 생성일
     */
    createdAt: Date
    /**
     * 솔라 사용 ID
     */
    assetSolarUsage: AssetSolarUsageValueObject
    /**
     * 은행 ID
     */
    envBank: EnvBankValueObject

    constructor(o: Record<keyof AssetSolarWithdrawalVerboseDomain, any>) {
        this.id = BigInt(o.id)
        this.assetSolarUsageId = BigInt(o.assetSolarUsageId)
        this.envBankId = BigInt(o.envBankId)
        this.account = String(o.account)
        this.cashAmount = Number(o.cashAmount)
        this.createdAt = new Date(o.createdAt)
        this.assetSolarUsage = new AssetSolarUsageValueObject(o.assetSolarUsage)
        this.envBank = new EnvBankValueObject(o.envBank)
    }
}
